var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['geoAreas', _vm.direction]},[_c('div',{staticClass:"geoAreas__name"},[_vm._v("Geographical area:")]),_c('div',{staticClass:"geoAreas__chips"},_vm._l((_vm.geoAreasList),function(g,index){return _c('button',{key:index,class:[
        'geoAreas__chips--chip',
        'chip',
        { selected: _vm.geoArea === g.key } ],on:{"click":function($event){return _vm.geoAreaClick(g.key)}}},[_vm._v(" "+_vm._s(g.name.toUpperCase())+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }